module.exports = __webpack_public_path__ + "img/DE01684.40473cc5.png";